import type { SplitDate, DateTextInputProps } from '../../DateTextInput.types'

function combineStringParts(dateParts: SplitDate, showMonthYearPicker: DateTextInputProps['showMonthYearPicker']): string {
  return showMonthYearPicker ? `${dateParts.month}/${dateParts.year}` : `${dateParts.day}/${dateParts.month}/${dateParts.year}`
}

export default combineStringParts
